/**
 * The player's LOCAL calendar date as 'YYYY-MM-DD'. Progression never reads a clock: the web
 * passes this string into daily / weekly logic (applyRunResult, dailyStatus, crafts' Favored
 * Slot). Tests pass a Date.
 */
export function localDateString(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Whether the user asked the OS for less motion (false outside a browser). */
export function prefersReducedMotion(): boolean {
  try {
    return typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}
